import hg002StatsPlot2 from "../../../../content/posts/data-release-notes/giab_2024.10/HG002_data.08.01.jsx";
import happyPlot from "../../../../content/posts/data-release-notes/giab_2024.10/happy_plot.06.01.jsx";
import truvariPlot from "../../../../content/posts/data-release-notes/giab_2024.10/truvari_hg002.07.12.jsx";
import * as React from 'react';
export default {
  hg002StatsPlot2,
  happyPlot,
  truvariPlot,
  React
};